import createNormalizer from 'utils/createNormalizer';
import {
  seriesSchemaEntity,
  bodyStyleSchemaEntity,
  modelsSchemaEntity,
} from '../schemas';

export const normalizeAllocation = createNormalizer({
  series: [seriesSchemaEntity],
  bodyStyles: [bodyStyleSchemaEntity],
  models: [modelsSchemaEntity],
});
